module.exports = __webpack_public_path__ + "img/banner.49742f3d.png";